import { client } from "api";
import { EditCustomerDetailsResponse } from "./editCustomerDetails";

export type EditSubcontractorRequest = {
  orderId: string;
  assignedToCompany: string | null;
};

export type EditSubcontractorResponse = EditCustomerDetailsResponse;

export const editSubcontractor = (params: EditSubcontractorRequest) =>
  client
    .post<EditSubcontractorResponse>(`/order/edit-customer-details`, params)
    .then((res) => res.data);
